import type { SVGProps } from 'react';
const SvgArtTrack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#art_track_svg__a)">
      <path
        fill="currentColor"
        d="M22 13h-8v-2h8v2Zm0-6h-8v2h8V7Zm-8 10h8v-2h-8v2Zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2Zm-1.5 6-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7Z"
      />
    </g>
    <defs>
      <clipPath id="art_track_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArtTrack;
